import { action } from '@ember/object';
import SettingsAreasBaseController from '../base';

export default class SettingsAreasListCreateController extends SettingsAreasBaseController {
  @action
  cancel() {
    // Delete the record instead of just rolling back
    this.model.destroyRecord();
    this.goToListPage();
  }
}
